import type { FieldDescriptor } from '../types/modal/FieldDescriptor';
import type { BusinessReportArray } from '../types/businessReport/BusinessReportGetResponse';
import type { BusinessReportPutRequest } from '../types/businessReport/BusinessReportPutRequest';
import { BusinessReportModalView } from '../types/businessReport/BusibessReportModalView';

export const BUSINESS_REPORT_HEADER = [
  { label: '日付', sortable: true, sortKey: 'br.date', width: '200px' },
  { label: 'PJ NO', sortable: false, sortKey: '', width: '220px' },
  { label: 'プロジェクト名', sortable: false, sortKey: '', width: '200px' },
  { label: '工数A', sortable: false, sortKey: '', width: '80px' },
  { label: '工数B', sortable: false, sortKey: '', width: '80px' },
  { label: '工数C', sortable: false, sortKey: '', width: '80px' },
  { label: '工数D', sortable: false, sortKey: '', width: '80px' },
  { label: '工数E', sortable: false, sortKey: '', width: '80px' },
  { label: '始業時間', sortable: false, sortKey: '', width: '180px' },
  { label: '終業時間', sortable: false, sortKey: '', width: '180px' },
  { label: '工数', sortable: false, sortKey: '', width: '80px' },
  { label: '操作', sortable: false, sortKey: '', width: '150px' },
];

export const BUSINESS_REPORT_DEFAULT_SORT_COLUMN = 'br.date';

export const BUSINESS_REPORT_MODAL_FIELDS: FieldDescriptor<BusinessReportModalView>[] =
  [
    { label: '日付', key: 'date', type: 'date' },
    { label: 'PJ No', key: 'projectNo', type: 'text' },
    { label: 'プロジェクト名', key: 'projectName', type: 'text' },
    { label: '工数A', key: 'manHoursA', type: 'checkbox' },
    { label: '工数B', key: 'manHoursB', type: 'checkbox' },
    { label: '工数C', key: 'manHoursC', type: 'checkbox' },
    { label: '工数D', key: 'manHoursD', type: 'checkbox' },
    { label: '工数E', key: 'manHoursE', type: 'checkbox' },
    { label: '始業時間', key: 'startTime', type: 'text' },
    { label: '終業時間', key: 'endTime', type: 'text' },
    { label: '工数合計', key: 'manHoursTotal', type: 'text' },
  ];
